import { useState } from "react";
import { Input } from "./ui/input";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { findSpace } from "../lib/findSpace";

export const UnitSearch = ({ spaces, onFound }) => {
  const [q, setQ] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const hit = findSpace(spaces, q);
    if (!hit) {
      if (q.trim()) toast.error(`No space found for "${q.trim()}"`);
      return;
    }
    onFound(hit.number);
    document
      .querySelector(`[data-testid="slot-${hit.number}"]`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
    setQ("");
  };

  return (
    <form onSubmit={submit} className="relative w-full sm:w-72" data-testid="unit-search-form">
      <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#A3A3A3]" />
      <Input
        data-testid="unit-search-input"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Find unit number or space"
        className="bg-[#0A0A0A] border-[#262626] rounded-sm h-9 pl-9"
      />
    </form>
  );
};
